import React from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import NumeriqueEntier from "../indicateurs/NumeriqueEntier";
import { Grid, InputAdornment } from "@material-ui/core";

const mapStateToProps = (state) => ({
  userRole: state.auth.role,
});

class PhytoAppliTrait extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    const indicToWatch = ["HVE4_PHYTO_I_70", "HVE4_PHYTO_S_70"];
    return indicToWatch.some((indic) => this.props.indicateurs[indic] !== nextProps.indicateurs[indic]);
  }

  handleChangeIndicateur = (newIndicateur) => {
    const { changeIndicateur, sousRubriqueIndex, libelleEnglobantIndex } = this.props;
    changeIndicateur(newIndicateur, sousRubriqueIndex, libelleEnglobantIndex);
  };

  render() {
    const { indicateurs, computedFields } = this.props;

    return (
      <React.Fragment>
        <div className={"d-flex align-items-center mt-2"}>
          <Grid container item xs={4}>
            {indicateurs["HVE4_PHYTO_I_70"].libelle}
          </Grid>
          <Grid container item xs={6}>
            <NumeriqueEntier
              size={"small"}
              indicateur={indicateurs["HVE4_PHYTO_I_70"]}
              key={"indicateur-" + indicateurs["HVE4_PHYTO_I_70"].idIndicateur}
              changeIndicateur={this.handleChangeIndicateur}
              valueInputProps={
                indicateurs["HVE4_PHYTO_I_70"].libelleUnite != null && {
                  endAdornment: (
                    <InputAdornment position={"end"}>{indicateurs["HVE4_PHYTO_I_70"].libelleUnite}</InputAdornment>
                  ),
                }
              }
              computedFields={computedFields}
            />
          </Grid>
        </div>
        <div className={"d-flex align-items-center mt-2"}>
          <Grid container item xs={4}>
            {indicateurs["HVE4_PHYTO_S_70"].libelle}
          </Grid>
          <Grid container item xs={6} className={"total-point"}>
            <NumeriqueEntier
              size={"small"}
              indicateur={indicateurs["HVE4_PHYTO_S_70"]}
              key={"indicateur-" + indicateurs["HVE4_PHYTO_S_70"].idIndicateur}
              changeIndicateur={this.handleChangeIndicateur}
              valueInputProps={
                indicateurs["HVE4_PHYTO_S_70"].libelleUnite != null && {
                  endAdornment: (
                    <InputAdornment position={"end"}>{indicateurs["HVE4_PHYTO_S_70"].libelleUnite}</InputAdornment>
                  ),
                }
              }
              computedFields={computedFields}
            />
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default compose(withTranslation(), connect(mapStateToProps))(PhytoAppliTrait);
